// @LTG-ID: contact-step-progress
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: source `Contact.html` lines 696-705, 720, 795, 879, 984, 1032 (v4)
// @CHANGED: 2026-05 session_006 (CHG-0083-M-A1-fix — ORCH-0086 ARIA hotfix)
// @OWNER: web
//
// CHG-0083-M-A1 — ProgressDots component.
//
// 5 dots; states: done (gold), active (teal, wider), unfilled (line-2).
// Text label "Step N of 5" in Geist Mono (hides under 680px via CSS).
//
// ARIA: rendered as <nav role="progressbar"> with aria-valuenow/valuemin/valuemax
// so screen-readers announce step progression (OQ-V4-6 proactive hook).
//
// CHG-0083-M-A1-fix (ORCH-0086) — independent-tester finding T4 closed:
//   - Inner dot spans previously carried aria-hidden="true" → REMOVED so the
//     step-flow widget is perceivable to assistive tech.
//   - Active step span now carries aria-current="step" (WAI-ARIA 1.2 step-flow
//     value); inactive spans intentionally do NOT carry aria-current.
//   - role="progressbar" + aria-valuenow/min/max retained (semantically valid
//     to coexist with per-step aria-current for step-flow widgets).
//   - aria-label enriched to "Step N of T: <ActiveStepName>" so SR users hear
//     the active step name on focus / on update.

// Active step labels — sourced verbatim from v4 source greetings:
//   StepName    → Contact.html line 720
//   StepBusiness→ Contact.html line 795
//   StepEmail   → Contact.html line 879
//   StepCategory→ Contact.html line 984
//   StepDetails → Contact.html line 1032
const STEP_NAMES = [
    "Who's reaching out",
    "The business",
    "Email verification",
    "What it's about",
    "The details",
];

export const StepProgress = ({ current, total }) => {
    const stepNum = Math.min(current + 1, total);
    const activeStepName = STEP_NAMES[current] || "";
    return (
        <nav
            className="ltgc-progress-row"
            role="progressbar"
            aria-valuenow={stepNum}
            aria-valuemin={1}
            aria-valuemax={total}
            aria-label={`Step ${stepNum} of ${total}: ${activeStepName}`}
            data-testid="contact-progress"
        >
            {Array.from({ length: total }).map((_, i) => {
                const isActive = i === current;
                const cls =
                    i < current
                        ? "ltgc-progress-dot is-done"
                        : isActive
                          ? "ltgc-progress-dot is-active"
                          : "ltgc-progress-dot";
                // aria-current="step" ONLY on the active dot (WAI-ARIA 1.2
                // step-flow value). Inactive dots carry no aria-current.
                // Inner dot spans are NOT aria-hidden — the step-flow widget
                // must be perceivable to assistive tech (ORCH-0086 T4 fix).
                const ariaCurrent = isActive ? "step" : undefined;
                return (
                    <span
                        key={i}
                        className={cls}
                        data-testid={`contact-progress-dot-${i}`}
                        aria-current={ariaCurrent}
                    />
                );
            })}
            <span
                className="ltgc-progress-label"
                data-testid="contact-progress-label"
            >
                Step {stepNum} of {total}
            </span>
        </nav>
    );
};

export default StepProgress;
